import React, {useState} from 'react';
import PropTypes from 'prop-types'

/* Utils */
import {
    useTheme,
    Box,
    Text
} from '@salesforce/retail-react-app/app/components/shared/ui'
import {
    RangeSlider,
    RangeSliderTrack,
    RangeSliderFilledTrack,
    RangeSliderThumb
} from '@chakra-ui/react'
import { FormattedMessage } from 'react-intl';
import useDetectDevice from '../../../hooks/use-detect-device'

/* Constants */
const DEFAULT_VALUE = 3;

const FitSelector = ({ onFitChange, options }) => {
    const theme = useTheme()
    const { isSafari } = useDetectDevice()
    const [selectedFit, setSelectedFit] = useState([DEFAULT_VALUE]);

    const handleOnChange = (selectedFitValue) => {
        setSelectedFit(selectedFitValue);

        if (onFitChange) {
            onFitChange(selectedFitValue);
        }
    }

    return (
        <Box>
            {options?.length > 0 &&
            (<>
                <Text {...theme.components.WriteReview.fieldTitle} mt={8}>
                    <FormattedMessage
                        defaultMessage="Actual fit *"
                        id="pdp_reviews.write.actual.fit"
                    />
                </Text>
                <Box position="relative" width="100%">
                    <RangeSlider defaultValue={[DEFAULT_VALUE]}
                        min={1}
                        max={options.length}
                        step={1}
                        onChangeEnd={handleOnChange}>
                        <RangeSliderTrack boxSize={'1px'} bg='black'>
                            <RangeSliderFilledTrack bg='black' />
                        </RangeSliderTrack>
                        <RangeSliderThumb boxSize={'12px'} index={0} bg='black' />
                    </RangeSlider>
                    <Box position="absolute" top="0" left="0" right="0" height="100%" pointerEvents="none">
                        {[...Array(5)].map((_, index) => (
                            <Box
                                key={index}
                                position="absolute"
                                left={`${(index / 4) * 100}%`}
                                top={isSafari ? '3.3px' : '7px'}
                                width="1px"
                                height="12px"
                                bg="black"
                            />
                        ))}
                    </Box>
                    <Box display="flex" justifyContent="space-between">
                        {options.map((option, index) => (
                            (index === 0 || index === 2 || index === options.length - 1) && (
                                <Text
                                    key={index}
                                    fontSize="xs"
                                >
                                    {option.Label}
                                </Text>
                            )
                        ))}
                    </Box>
                </Box>
            </>)
            }
        </Box>
    );
};

FitSelector.propTypes = {
    onFitChange: PropTypes.func,
    options: PropTypes.array.isRequired
};

export default FitSelector;
